import { render, staticRenderFns } from "./IncomeChart.vue?vue&type=template&id=184f77ba"
import script from "./IncomeChart.vue?vue&type=script&lang=ts"
export * from "./IncomeChart.vue?vue&type=script&lang=ts"
import style0 from "./IncomeChart.vue?vue&type=style&index=0&id=184f77ba&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184f77ba')) {
      api.createRecord('184f77ba', component.options)
    } else {
      api.reload('184f77ba', component.options)
    }
    module.hot.accept("./IncomeChart.vue?vue&type=template&id=184f77ba", function () {
      api.rerender('184f77ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/IncomeChart.vue"
export default component.exports